import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {

  constructor() { }

  set(KEY:string, value:string){
    localStorage.setItem(KEY, value);
  }

  remove(KEY:string){
    localStorage.removeItem(KEY);
  }

  get(KEY:string) : string | null {
    return localStorage.getItem(KEY);
  }
}



// WEBPACK FOOTER //
// C:/Users/egila/Downloads/temp/20260608_NuevoSAT/Trilce.Presentacion.Intranet.Profesores.NG5/src/app/support/services/storage.service.ts